import segment from 'util/analytics/segment'

export type Action =
  | 'opened'
  | 'closed'
  | 'completed_login'
  | 'completed_unknown_sign_up'
  | 'completed_director_sign_up'
  | 'completed_parent_sign_up'
  | 'completed_parent_sign_up_intermediate'
  | 'completed_parent_sign_up_final'

export interface ITrackData {
  sessionId: string
}

const events = {
  opened: 'Opened',
  closed: 'Closed',
  completed_login: 'Completed Login',
  completed_unknown_sign_up: 'Completed Unknown Sign Up',
  completed_director_sign_up: 'Completed Director Sign Up',
  completed_parent_sign_up: 'Completed Parent Sign Up',
  completed_parent_sign_up_final: 'Completed Parent Sign Up Final',
  completed_parent_sign_up_intermediate: 'Completed Parent Sign Up Intermediate',
}

export function track(action: Action, data: ITrackData) {
  segment.track(`Auth Modal ${events[action]}`, data)
}
